import React from 'react';
import { Empty } from 'antd';
import intl from 'react-intl-universal';
import './index.less';

const ListEmpty = ({ footer }: { footer?: React.ReactNode }) => {
  return (
    <div className="m-okr-list-empty">
      <Empty
        image={require('@/assets/img/no-data-okr.png')}
        description={intl.get('okr.list.empty').d('当前周期内暂无OKR')}
      >
        {footer}
      </Empty>
    </div>
  );
};

export default ListEmpty;
